export default function Hours() {
  const hours = [
    { day: 'Monday', time: '8:00 AM – 5:30 PM', isOpen: true },
    { day: 'Tuesday', time: '8:00 AM – 5:30 PM', isOpen: true },
    { day: 'Wednesday', time: '8:00 AM – 5:30 PM', isOpen: true },
    { day: 'Thursday', time: '8:00 AM – 5:30 PM', isOpen: true },
    { day: 'Friday', time: '8:00 AM – 5:30 PM', isOpen: true },
    { day: 'Saturday', time: '8:00 AM – 2:00 PM', isOpen: true },
    { day: 'Sunday', time: 'Closed', isOpen: false }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-amber-100 rounded-full mb-6">
              <i className="ri-time-line text-amber-600"></i>
              <span className="text-sm text-amber-900 font-semibold">Business Hours</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 font-['Space_Grotesk'] mb-6">
              When We're Open
            </h2>
            <p className="text-lg text-gray-600 mb-8">
              Visit us during our business hours or schedule an appointment for your convenience. We're here to serve you six days a week.
            </p>

            <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
              <div className="space-y-4">
                {hours.map((schedule, index) => (
                  <div 
                    key={index}
                    className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0"
                  >
                    <span className="text-sm font-semibold text-gray-900">
                      {schedule.day}
                    </span>
                    <span className={`text-sm font-medium ${schedule.isOpen ? 'text-gray-700' : 'text-red-600'}`}>
                      {schedule.time}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="relative h-[500px] rounded-2xl overflow-hidden shadow-xl">
            <iframe 
              src="https://www.google.com/maps/embed/v1/place?key=AIzaSyDoOLq_ts27g3vEog9sGYB0GJSyWBDK9gs&zoom=13&q=16116%20S%20Main%20St%2C%2090248%20Gardena"
              width="100%" 
              height="100%" 
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ace's Auto Body Shop location map"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}
